import { createAction } from 'redux-actions';

export const resetROPicklistEdit = createAction('RESET_RO_PICKLIST_EDIT');
